/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtractDocument202Response
 */
export interface ExtractDocument202Response {
    /**
     * ID of the document being processed
     * @type {number}
     * @memberof ExtractDocument202Response
     */
    documentId: number;
    /**
     * Processing status
     * @type {string}
     * @memberof ExtractDocument202Response
     */
    status: ExtractDocument202ResponseStatusEnum;
    /**
     * Human-readable status message
     * @type {string}
     * @memberof ExtractDocument202Response
     */
    message: string;
}


/**
 * @export
 */
export const ExtractDocument202ResponseStatusEnum = {
    Processing: 'processing'
} as const;
export type ExtractDocument202ResponseStatusEnum = typeof ExtractDocument202ResponseStatusEnum[keyof typeof ExtractDocument202ResponseStatusEnum];


/**
 * Check if a given object implements the ExtractDocument202Response interface.
 */
export function instanceOfExtractDocument202Response(value: object): value is ExtractDocument202Response {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ExtractDocument202ResponseFromJSON(json: any): ExtractDocument202Response {
    return ExtractDocument202ResponseFromJSONTyped(json, false);
}

export function ExtractDocument202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractDocument202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'status': json['status'],
        'message': json['message'],
    };
}

export function ExtractDocument202ResponseToJSON(json: any): ExtractDocument202Response {
    return ExtractDocument202ResponseToJSONTyped(json, false);
}

export function ExtractDocument202ResponseToJSONTyped(value?: ExtractDocument202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'status': value['status'],
        'message': value['message'],
    };
}

